import { RouterState } from '@frontend-site/shared/router-store';

export function isProjectScope(state: RouterState): boolean {
    const projectId = state?.params?.['projectId'];
    return !!projectId;
}
